export const LIGHT_NODE_NAMES = [
  "ps_logo_3d",
  "controller",
  "back_part_logo",
  "buttons_circle",
  "buttons_arrows_glass",
  "circles_right",
  "arrows _left",
  "buttons_little",
];

export const GRAY = "#020202";
export const BLACK = "#000000";
